import { render } from "./CreatePurchaseOrderView.vue?vue&type=template&id=457bc000&scoped=true"
import script from "./CreatePurchaseOrderView.vue?vue&type=script&lang=js"
export * from "./CreatePurchaseOrderView.vue?vue&type=script&lang=js"

import "./CreatePurchaseOrderView.vue?vue&type=style&index=0&id=457bc000&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457bc000"]])

export default __exports__